export default "__VITE_ASSET__Cgspu9Pg__"